/**
 * @file SendCode
 * @author
 * title: string，名称
 * isMsgRequired: boolean，是否必填项
 * type: email | phone
 */
import React, {useState, useRef} from 'react';

import LabelFormItem from '../LabelFormItem/index.tsx';
import {Input} from 'antd';
import {
    ExclamationCircleOutlined
} from '@ant-design/icons';
import message from 'antd/lib/message';
import './index.less';

interface Props {
    type: string;
    title: string;
    isMsgRequired: boolean;
    data: any;
    updateData?: any;
    errTip: string;
    style: {};
    sendData: string;
    fetchSendCode(param?: any): Promise<any>;
    placeholder?:string;
    disabled?: boolean;
    onChange?:any;
    onBlur?:any;
    onSendCodeChange?:any;
}
const codeData = {
    'emailCode': 1,
    'phoneCode': 2
};

export default function SendCode(props: Props) {
    const {
        type,
        title,
        isMsgRequired,
        data,
        updateData,
        sendData,
        fetchSendCode,
        onChange,
        onBlur,
        onSendCodeChange
    } = props;

    const [captchaBtnStatus, setCaptchaBtnStatus] = useState(true); // 获取验证码按钮状态
    const [count, setCount] = useState(60); // 时长
    const [captchaTip, setCaptchaTip] = useState('获取验证码'); // 获取验证码
    const timer = useRef<number>();
    // 设置定时器
    const setTimer = () => {
        let curCount = count;
        timer.current = setInterval(() => {
            let newCount = --curCount;
            if (newCount <= 0) {
                timer.current && clearInterval(timer.current);
                newCount = 60;
            }
            setCaptchaBtnStatus(newCount === 60);
            setCount(newCount);
            setCaptchaTip('重新获取');
        }, 1000);
    };
    const sendCodeFn = () => {
        onSendCodeChange && onSendCodeChange({captchaTip});
        /* eslint-disable */
        window.BCat_2055 && window.BCat_2055.miao();
        window['__abbaidu_2055_cb'] = responseData => {
            window['___abbaidu_2055_cb'] = null;
            let localData = JSON.parse(responseData);
            fetchSendCode({
                type: codeData[type],
                action: 'delegation_auth',
                data: localData.data,
                key_id: localData['key_id'],
                sign: localData.sign,
                verity: sendData
            })
            .then(data => {
                const {code} = data || {};
                if (code === 200) {
                    setTimer();
                } else {
                    message.error(data.message);
                }
            }).catch(() => {});
        };
        /* eslint-enable */
    };
    const onInputChange = (e:{target: {value: string}}) => {
        updateData && updateData({
            [type]: e.target.value,
            [type + 'Err']: ''
        });
        onChange && onChange(e);
    };

    const onInputBlur = (e:{target: {value: string}}) => {
        updateData({
            [type]: e.target.value,
            [type + 'Err']: ''
        });
        onBlur && onBlur(e);
    };
    return (
        <div className={'form-item-send-code'}>
            {title && <LabelFormItem isMsgRequired={isMsgRequired} title={title} />}
            <div style={{position: 'relative'}}>
                <Input
                    className={
                        data[type + 'Err']
                            ? 'custom-input get-code-input border-error'
                            : 'custom-input get-code-input'
                    }
                    placeholder="输入验证码"
                    size="large"
                    value={data[type]}
                    onChange={onInputChange}
                    onBlur={onInputBlur}
                    addonAfter={<div className={'get-code ' + (!captchaBtnStatus ? 'disable' : '')}
                        onClick={sendCodeFn}>
                        {!captchaBtnStatus ? count + 's' : captchaTip}
                    </div>}
                />
                {data[type + 'Err'] && <p className="form-item-input-err">
                    <ExclamationCircleOutlined style={{marginRight: '4px'}} />
                    {data[type + 'Err']}</p>}
            </div>

        </div>
    );
}
